import React from "react";
import { useShoppingContext } from "../../../../context/ShoppingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarehouse } from "@fortawesome/free-solid-svg-icons";
import AddGalponForm from "../../Forms/AddGalponForm/AddGalponForm";

const AddGalpon = () => {
  const { setShowAddGalpon, showAddGalpon} = useShoppingContext();
  return (
    <div className="text-center">
      <button
        className={"btn btn-green w-100"}
        onClick={() => setShowAddGalpon(!showAddGalpon)}
      >
        <FontAwesomeIcon icon={faWarehouse } />{" "}
        Nuevo Galpón
      </button>
      {showAddGalpon && <AddGalponForm />}
    </div>
  );
};

export default AddGalpon;
